import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import {ButtonController, IButtonControllerOptions} from '../../Common/ButtonController';
import {GameLogic} from '../../Logic/GameLogic';
import {BoosterNameEnum, BoosterTypeEnum, GameModel, InstrumentTypeEnum} from '../../Models/GameModel';
import {GameEvent, GameEventSceneButtonClick} from '../../Constants/GameEvent';

export interface IBoosterListItemControllerOptions {
    type: BoosterTypeEnum;
}

export class BoosterListItemController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _model: GameModel,
    ) {
        super('BoosterListItemController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn: {
                    instanceName: 'btn',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            if (this._options.type === BoosterTypeEnum.yarn) {
                                this._gameLogic.setColor(0);
                            }
                            const buttonName = this.getButtonNameByType(this._options.type);
                            this._modelEvents.dispatch(this._model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName, status });

                            if (!status) {
                                return;
                            }

                            this._gameLogic.setBoosterType(this._options.type);
                        },
                    },
                },
            },
            modelEvents: {
                setBoosterType: (value: BoosterTypeEnum) => {
                    this.checkIcon();
                    this.checkIconPlus();
                },
                setInstrumentType: (value: InstrumentTypeEnum) => {
                    this.checkIcon();
                    this.checkIconPlus();
                },
                changeBoosterCount: (value: BoosterTypeEnum, count: number) => {
                    this.checkIcon();
                    this.checkIconPlus();
                }
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop('normal');
        this.checkIconPlus();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    private checkIcon(): void {
        const instrument = this._gameLogic.getInstrumentType();
        const type = this._gameLogic.getBoosterType();

        let value = type === this._options.type ? 'selected' : 'normal';
        value = instrument === InstrumentTypeEnum.booster ? value : 'normal';

        this.gotoAndStop(value);
    }

    private checkIconPlus() {
        this.getDisplayObjectByQuery('btn_buy')[0].visible = this.getBusterCount() === 0;
        this.getDisplayObjectByQuery('btn_count')[0].visible = this.getBusterCount() !== 0;
        const text = this.getDisplayObjectByQuery('btn_count.txt')[0] as PIXI.Text;
        text.text = this.getBusterCount().toFixed();
    }

    private getBusterCount(): number {
        return this._gameLogic.getBoosterCount(this._options.type);
    }

    private getButtonNameByType(type: BoosterTypeEnum): BoosterNameEnum {
        switch (type) {
            case BoosterTypeEnum.needle:
                return BoosterNameEnum.needle;

            case BoosterTypeEnum.yarn:
                return BoosterNameEnum.yarn;

            case BoosterTypeEnum.bucket:
                return BoosterNameEnum.bucket;
        }
    }
}
